import React from "react";
import { FormGroup, ModalBody, ModalHeader, Input, Label, Button, Form } from "reactstrap";
import SimpleReactValidator from "simple-react-validator";
import { addExpertize, updateExpertize} from "../../../services/expertizeService";
import { notifyError, notifySuccess } from "../../../utils/utils";
import Loader from "../../../utils/Loader";

class AddExpertize extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            expertize: "",
            alertModel: false,
            alertMessage: "",
            loading: false
        };

        this.validator = new SimpleReactValidator({
            locale: 'en', messages:{}, autoForceUpdate: this,
            validators: {
                expertise: {
                    message: "Expertise name contains only Alphabet, Numbers and Symbols ,-'[]()&",
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val,  /^[\w&.,'/\s/g\[\]()\-]+$/)
                    }
                }
            }
        });

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleResponse = this.handleResponse.bind(this);
    }

    handleSubmit(e) {
        e.preventDefault();
        if(!this.validator.allValid()){
            this.validator.showMessages();
            this.forceUpdate();
            return;
        }
        const data = { expertise_name: this.state.expertize};
        this.setState({ loading: true });
        if(this.props.isEditing) {
            updateExpertize(this.state.id, data)
            .then(res => this.handleResponse(res.data))
        } else {
            addExpertize(data).then(res => this.handleResponse(res.data)); 
        }
    }

    handleResponse(data) {
        if(data.status) {
            notifySuccess(data.message);
            setTimeout(() => {
                this.props.toggle();
                this.props.reload();
            }, 1000);
        } else {
            this.setState({ loading: false });
            notifyError(data.message);
        }
    }

    
    componentDidMount(){
        if(this.props.isEditing){
            this.setState({
                expertize: this.props.expertize.expertise_name,
                id: this.props.expertize.expertise_id
            });
        }
    }

    render() {
        this.validator.purgeFields();

        const { expertize } = this.state;

        return(

            <React.Fragment>
                {/* <div className="page-content">
                    <Container fluid> */}
                        <ModalHeader toggle={() => this.props.toggle()}> 
                            {this.props.isEditing ? "Edit" : "Add"} Expertize
                        </ModalHeader>
                        <ModalBody>
                       
                            <Form onSubmit={this.handleSubmit}>

                                <FormGroup>
                                    <Label>Expertize</Label>
                                    <Input
                                        type="text"
                                        name="expertize"
                                        value={expertize}
                                        onChange={e => {
                                            this.setState({
                                                expertize: e.target.value
                                            });
                                        }}
                                    />
                                <span className="text-danger">
                                    {this.validator.message('expertize name', expertize, 'required|min:2|max:30|expertise')}
                                </span>
                                </FormGroup>

                                <FormGroup className="pull-right">
                                {
                                    this.state.loading
                                        ?
                                        <Loader />
                                        // <Spinner style={{ width: '3rem', height: '3rem' }}  color="primary" />
                                        :
                                        <Button color="success" type="submit">Submit</Button> 
                                }
                                </FormGroup>
                            </Form>
                        </ModalBody>
                    {/* </Container>
                </div> */}
            </React.Fragment>
        )
    }
}

export default AddExpertize;